import React, { useEffect, useState } from "react"
import { StyleSheet, Text, View, AppRegistry, NativeModules} from "react-native"
import { MyButton } from "./buttonsAndControls"
import { Modal, Portal } from "react-native-paper";

const darkColour='#2a2d3e';

export const FirstTime = ({onClicked=()=>{}, firstTime = false}) => {
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const [showBackdated, setShowBackdated] = useState(false)

  useEffect(() => {
    // Fetch the computer's date and time once on app launch
    const fetchDateTimeFromComputer = async () => {
      const dateTimeFromComputer = new Date(); // Replace this with a function to fetch the time from the computer
      setCurrentDateTime(dateTimeFromComputer);
    };

    fetchDateTimeFromComputer();

    // Update current date and time every second
    const timerId = setInterval(() => {
      setCurrentDateTime((prevDateTime) => {
        // Create a new Date object with the previous date and time
        const newDateTime = new Date(prevDateTime);
        // Add one second to the current time
        newDateTime.setSeconds(newDateTime.getSeconds() + 1);
        return newDateTime;
      });
    }, 1000);

    // Cleanup the interval when the component unmounts
    return () => clearInterval(timerId);
  }, []);

  const handleExitApp = () => {

  };

  return (
    <Portal>
      <Modal visible={firstTime} onDismiss={() => firstTime} dismissable={false} contentContainerStyle={stylesBox.modalContainer}>
        <View style ={stylesBox.firstTime}>
          <Text style={stylesBox.headerText} >
          {`Welcome to your first time of using the StockAware app.`}
          </Text>
          <View style={{flexDirection:'row'}} >
            <Text style ={stylesBox.noteBoldText}>
              {`Note (very important):`}
            </Text>
            <Text style ={stylesBox.noteText}>
                Always confirm that your date and time is accurate{"\n"}
                before you launch this app, you may want to toggle{"\n"}
                on the <Text style={stylesBox.noteBoldText}>"Set time automatically"</Text> on your Date & time{"\n"}
                settings. <Text style={stylesBox.noteBoldText}>StockAware</Text> records your date and time at{"\n"}
                the first ever launch, and compares your date and{"\n"}
                time before performing any writing to its database.{"\n"}
                Also note that altering your date or time may cause{"\n"}
                the app not to function.
            </Text>
          </View>
          <Text style ={stylesBox.noteText}>
            Your current date and time is: {"\n"}<Text style={stylesBox.noteBoldText}>{currentDateTime.toString()}</Text> {"\n"}
            Be informed, this is the date and time <Text style={stylesBox.noteBoldText}>StockAware</Text> will work with. 
            Be sure to confirm that the above date is accurate before proceeding, otherwise exit this app and set correctly, your date and time. 
          </Text>

          <View style={stylesBox.modalButtonContainer}>
            <View>
              <MyButton btnText="Date and time correct, Proceed" btnWidth={290} hndClicked={()=>{onClicked()}} />
            </View>
            <View>
              <MyButton btnText="Exit" btnWidth={100} btnColor="white" btnBorClr= {darkColour} 
              btnTxtClr= {darkColour} btnBorWdt={2} btnPadding={7} hndClicked={()=>{handleExitApp()}} />
            </View>
          </View>
        </View>
      </Modal>
    </Portal>
  )
};

export const Backdated = ({onClicked=()=>{}, backdated = false}) => {

  return (
    <Portal>
    <Modal visible={backdated} onDismiss={() => backdated} dismissable={false} contentContainerStyle={stylesBox.backdatedModalContainer}>
      <View style ={stylesBox.backdated}>
        <Text style={stylesBox.headerText} >
        {`Backdated.`}
        </Text>
        <View style={{flexDirection:'row'}} >
          <Text style ={stylesBox.noteBoldText}>
            {`Problem:`}
          </Text>
          <Text style ={stylesBox.noteText}>
            <Text style={stylesBox.noteBoldText}>StockAware</Text> has noticed there has been {"\n"}
            a tampering of date or time, hence its {"\n"}usage is temporarily halted.
          </Text>
        </View>
        <View style={{flexDirection:'row'}} >
          <Text style ={stylesBox.noteBoldText}>
            {`Fix:`}
          </Text>
          <Text style ={stylesBox.noteText}>
            Correct your date and time, and try again. If {"\n"}that did not work, correct your date and time, {"\n"}
            then wait for a minute before trying again. If all {"\n"}the above did not work, contact your boss.
          </Text>
        </View>

        <View style={stylesBox.backdatedButtonContainer}>
          <View>
            <MyButton btnText="Close" btnWidth={100} hndClicked={()=>{onClicked()}} />
          </View>
        </View>
      </View>
    </Modal>
  </Portal>
  )
}

const stylesBox=StyleSheet.create ({
  firstTime: {
    width: 580, 
    height:400, 
    borderWidth:2, 
    borderRadius:10, 
    borderColor:darkColour, 
    backgroundColor:'white',
  },
  backdated: {
    width: 400, 
    height:250, 
    borderWidth:2, 
    borderRadius:10, 
    borderColor:darkColour, 
    backgroundColor:'white',
  },
  modalButtonContainer: {
    width:575, 
    flexDirection:'row-reverse', 
    marginTop:50,
    justifyContent:"space-between",
    paddingHorizontal:15
  },
  backdatedButtonContainer: {
    width:395, 
    flexDirection:'row-reverse', 
    marginTop:10,
    justifyContent:"space-between",
    paddingHorizontal:15
  },
	noteText: {
    color: darkColour, 
    fontFamily:'century gothic', 
    fontSize:15, 
    fontWeight:'normal', 
    textAlign:'left',
    marginLeft:10,
    marginTop:10
	},
  noteBoldText: {
    color: darkColour, 
    fontFamily:'century gothic', 
    fontSize:15, 
    fontWeight:'bold', 
    textAlign:'left',
    marginLeft:10,
    marginTop:10
	},
  headerText: {
    alignSelf:'center', 
    fontSize:17, 
    marginTop:10, 
    fontWeight:'bold', 
    textDecorationLine:'underline', 
    color: darkColour, 
    fontStyle:'italic'
  },
  modalContainer: {
		justifyContent: 'center',
		alignItems: 'center',
    alignSelf:'center',
		backgroundColor: 'white',
		width:580, 
		height:400, 
		borderWidth:1, 
		borderColor:darkColour, 
		borderRadius:10, 
  },
  backdatedModalContainer: {
		justifyContent: 'center',
    alignSelf:'center',
		alignItems: 'center',
		backgroundColor: 'white',
		width:400, 
		height:250, 
		borderWidth:1, 
		borderColor:darkColour, 
		borderRadius:10, 
  }
})

export default Backdated